__turbopack_context__.v({
  "active": "styles-module__CEfRuG__active",
  "extraHigh": "styles-module__CEfRuG__extraHigh",
  "fade-in": "styles-module__CEfRuG__fade-in",
  "fade-out": "styles-module__CEfRuG__fade-out",
  "fadeDelaySequence": "styles-module__CEfRuG__fadeDelaySequence",
  "mobileMenuFooter": "styles-module__CEfRuG__mobileMenuFooter",
  "mobileMenuFooterActive": "styles-module__CEfRuG__mobileMenuFooterActive",
  "tall": "styles-module__CEfRuG__tall",
  "underline": "styles-module__CEfRuG__underline",
  "underlineActive": "styles-module__CEfRuG__underlineActive",
  "wide": "styles-module__CEfRuG__wide",
});
